import {ChangeDetectorRef, Component, Inject} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Membership} from "../../../@services/gen";
import {DecimalPipe} from "@angular/common";
import {ExtendedOrder} from "../../pos/pos-split-bill-dialog/pos-split-bill-dialog.component";

@Component({
  selector: 'app-redeem-points-dialog',
  templateUrl: './redeem-points-dialog.component.html',
  styleUrls: ['./redeem-points-dialog.component.scss']
})
export class RedeemPointsDialogComponent {
  membership: Membership;
  total: number = 0;
  redeemPoints: number = 0;
  constructor(private dialogRef: MatDialogRef<RedeemPointsDialogComponent>, @Inject(MAT_DIALOG_DATA) private data: any, private decimalPipe: DecimalPipe) {
    this.membership = data.membership;
    this.total = data.total;
    this.getRedeemPoint();
  }

  submit() {
    this.getRedeemPoint();

    this.dialogRef.close({
      redeemPoints: this.redeemPoints,
    });
  }

  getFormattedPoints(): string {
    const points = +this.membership?.availablePoints - +this.total;
    return this.decimalPipe.transform(points, '1.2-2');
  }

  getRedeemPoint(){
    let redeemPoint = 0;
    if(this.membership.availablePoints > this.total){
      redeemPoint = +this.total;
    } else {
      redeemPoint = +this.membership?.availablePoints;
    }

    this.redeemPoints = redeemPoint;
  }
}
